<script setup lang="ts">
import LayoutSection from "~/components/layout/Section.vue";

const actualYear: number = new Date().getFullYear();
</script>

<template>
  <LayoutSection id="footer" background="rgb(var(--dark-background))">
    <div class="group">
      <div class="section-head">
        <NuxtLink to="/" class="brand">
          <span>Roja</span>Tac
        </NuxtLink>

        
        <p>Poctivá česká firma specializující se na zemní a výkopové práce, úpravy terénu a odvoz či dovoz zeminy. Poskytujeme spolehlivé a efektivní služby pro zákazníky ve Velkých Bílovicích a okolí Břeclavi, Mikulova a Hustopečí.</p>
      </div>

      <div class="links">
        <div class="column">
          <h3>Rychlé odkazy</h3>
          <ul>
            <li><NuxtLink to="/#services">Služby</NuxtLink></li>
            <li><NuxtLink to="/projects">Projekty</NuxtLink></li>
            <li><NuxtLink to="/#about-us">O nás</NuxtLink></li>
          </ul>
        </div>

        <div class="column">
          <h3>Další</h3>
          <ul>
            <li><NuxtLink to="#contact">Kontakt</NuxtLink></li>
            <li><NuxtLink to="/privacy-policy">Ochrana osobních údajů</NuxtLink></li>
          </ul>
        </div>
      </div>
    </div>

    <span class="line"></span>

    <div class="bottom-info">
      <p class="copyright">© {{ actualYear }} <span>RojaTac</span>. Všechna práva vyhrazena.</p>
      <p class="author">Tento web vytvořil <NuxtLink to="https://rufubit.cz">Rufubit.cz</NuxtLink></p>
    </div>
  </LayoutSection>
</template>

<style scoped lang="scss">
.section-head {
  display: flex;
  flex-direction: column;
  gap: 10px;

  span {
    font-size: 18px;
    font-weight: 700;
    color: rgb(var(--main-color));
    text-transform: uppercase;
  }

  h2 {
    font-size: 36px;
    font-weight: 700;
    color: rgb(var(--title-light-color));
  }

  p {
    font-size: 18px;
    color: rgb(var(--text-light-color));
  }
}

#footer {
  display: flex;
  flex-direction: column;
  gap: 60px;
  padding-bottom: 60px;

  .group {
    display: flex;
    flex-direction: row;
    gap: 60px;
    justify-content: space-between;
    flex-wrap: wrap;

    .section-head {
      max-width: 600px;

      .brand {
        font-size: 27px;
        text-transform: uppercase;
        font-weight: 700;
        color: rgb(var(--title-dark-color));
        text-decoration: none;

        span {
          font-size: 27px;
          color: rgb(var(--main-color));
        }
      }

      p {
        font-size: 18px;
        color: rgb(var(--text-dark-color));
      }
    }

    .links {
      display: flex;
      flex-direction: row;
      gap: 60px;
      flex-wrap: wrap;

      .column {
        display: flex;
        flex-direction: column;
        gap: 20px;

        h3 {
          font-size: 18px;
          font-weight: 700;
          color: rgb(var(--title-dark-color));
        }

        ul {
          list-style: none;
          display: flex;
          flex-direction: column;
          gap: 10px;

          li a {
            text-decoration: none;
            font-size: 18px;
            color: rgb(var(--text-dark-color));
            transition: 0.2s;

            &:hover {
              color: rgb(var(--main-color));
            }
          }
        }
      }
    }
  }

  .line {
    width: 100%;
    height: 2px;
    background: rgba(var(--mini-title-dark-color), 0.2);
    border-radius: var(--small-border-radius);
  }

  .bottom-info {
    display: flex;
    flex-direction: row;
    gap: 30px;
    justify-content: space-between;
    flex-wrap: wrap;
    font-size: 18px;

    .copyright {
      color: rgb(var(--text-dark-color));

      span {
        color: rgb(var(--main-color));
        text-transform: uppercase;
      }
    }

    .author {
      color: rgb(var(--text-dark-color));

      a {
        color: rgb(var(--main-color));
        text-decoration: none;
      }
    }
  }
}
</style>